// ------------------------ 24-02-2026 ------------------- update code
import React, { useEffect, useState } from "react";
import {
  Search,
  Download,
  Printer,
  FileSpreadsheet,
  FileText,
} from "lucide-react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Apiurl from "../environment/Apiurl";

const Report = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [error, setError] = useState(null);
  const [billingData, setBillingData] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);

  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedServiceHome, setSelectedServiceHome] = useState("");
  const [billType, setBillType] = useState("");
  const [paytype, setPaytype] = useState("");

  const todayDate = new Date().toISOString().split("T")[0];
  const [fromDate, setFromDate] = useState(todayDate);
  const [toDate, setToDate] = useState(todayDate);
  const navigate = useNavigate();

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const formatCurrentDate = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = String(today.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const formatAmount = (amount) => {
    if (!amount || isNaN(amount)) return "0.00";
    return Math.round(Number(amount)).toFixed(2);
  };

  const calculateServiceAmount = (service) => {
    const basePrice = Number(service.basePrice) || 0;
    const quantity = Number(service.quantity) || 1;
    const taxPercentage = Number(service.tax_percentage) || 0;
    const itemTotal = basePrice * quantity;
    const taxAmount = itemTotal * (taxPercentage / 100);
    return itemTotal + taxAmount;
  };

  const isPrimaryBill = (item) => {
    return item.bill_no === item.ref_no;
  };

  const calculateMetrics = (data) => {
    const totalAmount = data.reduce((sum, item) => {
      const serviceTotal =
        item.service_list?.reduce(
          (acc, service) => acc + calculateServiceAmount(service),
          0,
        ) || 0;
      return sum + serviceTotal;
    }, 0);

    const totalAdvance = data.reduce(
      (sum, item) => sum + (parseFloat(item.advance_amount) || 0),
      0,
    );

    const totalCash = data.reduce(
      (sum, item) => sum + (parseFloat(item.cash) || 0),
      0,
    );

    const balance = data.reduce(
      (sum, item) => sum + (parseFloat(item.payment?.[0]?.balance) || 0),
      0,
    );

    const totalPhonepe = data.reduce(
      (sum, item) =>
        item.Paytype.toLowerCase() === "phonepe"
          ? sum + parseFloat(item.payment?.[0]?.amount || 0)
          : sum,
      0,
    );

    const totalPayCash = data.reduce(
      (sum, item) =>
        item.Paytype.toLowerCase() === "cash"
          ? sum + parseFloat(item.payment?.[0]?.amount || 0)
          : sum,
      0,
    );

    const totalBankTransfer = data.reduce(
      (sum, item) =>
        item.Paytype.toLowerCase() === "bank transfer"
          ? sum + parseFloat(item.payment?.[0]?.amount || 0)
          : sum,
      0,
    );

    const totalCard = data.reduce(
      (sum, item) =>
        item.Paytype.toLowerCase() === "card"
          ? sum + parseFloat(item.payment?.[0]?.amount || 0)
          : sum,
      0,
    );

    const totalPaid = data.reduce(
      (sum, item) => sum + parseFloat(item.payment?.[0]?.amount || 0),
      0,
    );

    const totalNetAmount = data.reduce(
      (sum, item) => sum + (parseFloat(item.net_total) || 0),
      0,
    );

    // const balance = totalNetAmount - totalPaid - totalCash;
    // const balance = 0;

    return {
      totalAmount,
      totalCash,
      totalPhonepe,
      totalPayCash,
      totalBankTransfer,
      totalCard,
      totalAdvance,
      totalNetAmount,
      totalPaid,
      balance,
    };
  };

  const fetchBillingData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/generalbill`);
      const uniqueBills = Array.from(
        new Map(response.data.map((item) => [item.bill_no, item])).values(),
      ).reverse();

      console.log("Data Recevied :", uniqueBills);
      setBillingData(uniqueBills || []);
      setError(null);
    } catch (error) {
      console.error("Error fetching billing data:", error.message);
      setError("Failed to fetch billing data. Please try again.");
    }
  };

  const fetchServiceTypes = async () => {
    try {
      const response = await axios.get(`${Apiurl}/service`);
      setServiceTypes(response.data || []);
    } catch (error) {
      console.error("Error fetching service types:", error.message);
      setError("Failed to fetch service types.");
    }
  };

  const fetchBrands = async () => {
    try {
      const response = await axios.get(`${Apiurl}/brand`);
      setBrands(response.data || []);
    } catch (error) {
      console.error("Error fetching brands:", error.message);
      setError("Failed to fetch brands.");
    }
  };

  const fetchModels = async () => {
    try {
      const response = await axios.get(`${Apiurl}/model`);
      setModels(response.data || []);
    } catch (error) {
      console.error("Error fetching models:", error.message);
      setError("Failed to fetch models.");
    }
  };
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({
      top: 0,
      behavior: "smooth", // optional for smooth scrolling
    });
  }, []);

  useEffect(() => {
    fetchBillingData();
    fetchServiceTypes();
    fetchBrands();
    fetchModels();
  }, []);

  const getCurrentData = (filteredData, startIndex) => {
    return filteredData.map((item, index) => ({
      sNo: startIndex + index + 1,
      date: item.date || "N/A",
      name: item.name || "N/A",
      mobile_no: item.mobile_no || "N/A",
      Paytype: item.Paytype || "N/A",
      brand: item.brand || "N/A",
      model: item.model || "N/A",
      bill_no: item.bill_no || "N/A",
      ref_no: item.ref_no || "N/A",
      service_list: item.service_list || [],
      technician: item.technician || "N/A",
      bill_staff: item.bill_staff || "N/A",
      gstin: item.gstin || "0",
      advance_amount: item.advance_amount || "0",
      net_total: item.net_total || "0",
      sub_total: item.sub_total || "0",
      cash: item.cash || "0",
      payment_amount: item.payment?.[0]?.amount || "0",
      balance: item.payment?.[0]?.balance || "0",
    }));
  };

  const getFilteredData = () => {
    let filteredData = billingData;
    filteredData = Array.from(
      new Map(filteredData.map((item) => [item.bill_no, item])).values(),
    );

    if (searchTerm) {
      filteredData = filteredData.filter(
        (item) =>
          Object.values(item)
            .filter((value) => typeof value === "string")
            .some((value) =>
              value.toLowerCase().includes(searchTerm.toLowerCase()),
            ) ||
          item.service_list.some((service) =>
            Object.values(service)
              .filter((value) => typeof value === "string")
              .some((value) =>
                value.toLowerCase().includes(searchTerm.toLowerCase()),
              ),
          ) ||
          item.Paytype.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }

    if (selectedServiceType) {
      filteredData = filteredData.filter((item) =>
        item.service_list.some(
          (service) => (service.serviceType || "") === selectedServiceType,
        ),
      );
    }
    if (selectedBrand) {
      filteredData = filteredData.filter(
        (item) => item.brand === selectedBrand,
      );
    }
    if (selectedModel) {
      filteredData = filteredData.filter(
        (item) => item.model === selectedModel,
      );
    }
    if (selectedServiceHome) {
      filteredData = filteredData.filter((item) =>
        item.service_list.some(
          (service) => service.serviceName === selectedServiceHome,
        ),
      );
    }

    // if (billType) {
    //   filteredData = filteredData.filter(
    //     (item) =>
    //       (item.gstin && item.gstin !== "0" ? "gst" : "general") === billType,
    //   );
    // }

    if (billType) {
      filteredData = filteredData.filter((item) => {
        const billNo = item.bill_no || "";

        if (billType === "general") {
          return billNo.startsWith("WC");
        }

        if (billType === "motorola") {
          return billNo.startsWith("MO");
        }

        if (billType === "gst") {
          return billNo.startsWith("IN");
        }

        return true;
      });
    }

    if (paytype) {
      filteredData = filteredData.filter((item) => item.Paytype === paytype);
    }

    if (fromDate && toDate) {
      filteredData = filteredData.filter(
        (item) =>
          new Date(item.date) >= new Date(fromDate) &&
          new Date(item.date) <= new Date(toDate),
      );
    }

    return filteredData;
  };

  const getPaginatedData = () => {
    const filteredData = getFilteredData();
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredData.slice(
      startIndex,
      startIndex + itemsPerPage,
    );
    return getCurrentData(paginatedData, startIndex);
  };

  const getTotalPages = () => {
    const filteredDataLength = getFilteredData().length;
    return Math.ceil(filteredDataLength / itemsPerPage) || 1;
  };

  // Handle CSV
  const downloadCSV = () => {
    const filteredData = getFilteredData();

    const headers = [
      "S.No",
      "Bill Date",
      "Bill No",
      "Customer",
      "PayType",
      "Brand",
      "Model",
      "HSN Code",
      "Charge Type",
      "Total",
      "Phonepe",
      "Cash",
      "Advance",
      "Cash Bal",
      "Technician",
      "Bill Staff",
    ];

    let csvContent = headers.join(",") + "\n";

    const {
      totalNetAmount,
      totalPhonepe,
      totalCash,
      totalAdvance,
      totalBankTransfer,
      totalPayCash,
      balance,
      totalCard,
    } = calculateMetrics(filteredData);

    filteredData.forEach((item, index) => {
      const sNo = index + 1;
      const payment = item.payment?.[0] || {};

      /* ---------------- PHONEPE ---------------- */
      const phonePeAmount =
        item.Paytype?.toLowerCase() === "phonepe"
          ? formatAmount(payment.amount || 0)
          : "0.00";

      /* ---------------- CASH LOGIC (FIXED) ---------------- */
      const isCashPayment =
        item.Paytype?.toLowerCase() === "cash" ||
        payment.payment_type?.toLowerCase() === "cash";

      const cashAmount =
        parseFloat(item.cash || 0) +
        (isCashPayment ? parseFloat(payment.amount || 0) : 0);

      const cashDisplay = formatAmount(cashAmount);

      const balanceAmount = parseFloat(payment.balance || 0);
      const balanceDisplay = formatAmount(balanceAmount);

      if (item.service_list?.length > 0) {
        item.service_list.forEach((service, serviceIndex) => {
          const row = [
            sNo,
            `"${formatDate(item.date)}"`,
            `"${item.bill_no || "N/A"}"`,
            `"${item.name || "N/A"}"`,
            `"${item.Paytype || "N/A"}"`,
            `"${item.brand || "N/A"}"`,
            `"${item.model || "N/A"}"`,
            `"${service.hsnCode || "N/A"}"`,
            `"${service.serviceName || "N/A"}"`,

            serviceIndex === 0 ? formatAmount(item.net_total) : 0,

            phonePeAmount,

            serviceIndex === 0 ? cashDisplay : 0,

            serviceIndex === 0 ? formatAmount(item.advance_amount || 0) : 0,

            serviceIndex === 0 ? cashDisplay : 0,

            `"${item.technician || "N/A"}"`,
            `"${item.bill_staff || "N/A"}"`,
          ].join(",");

          csvContent += row + "\n";
        });
      } else {
        const row = [
          sNo,
          `"${formatDate(item.date)}"`,
          `"${item.bill_no || "N/A"}"`,
          `"${item.name || "N/A"}"`,
          `"${item.Paytype || "N/A"}"`,
          `"${item.brand || "N/A"}"`,
          `"${item.model || "N/A"}"`,
          "",
          "",
          formatAmount(item.net_total),
          phonePeAmount,
          cashDisplay,
          formatAmount(item.advance_amount || 0),
          cashDisplay,
          `"${item.technician || "N/A"}"`,
          `"${item.bill_staff || "N/A"}"`,
        ].join(",");

        csvContent += row + "\n";
      }
    });

    /* ---------------- TOTAL ROW ---------------- */
    const totalRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "Total:",
      formatAmount(totalNetAmount - totalAdvance),
      formatAmount(totalPhonepe),
      formatAmount(totalCash + totalPayCash),
      formatAmount(totalAdvance),
      formatAmount(totalCash + totalPayCash),
      "",
      "",
    ].join(",");

    csvContent += totalRow + "\n\n";

    /* ---------------- SUMMARY (PDF LIKE) ---------------- */
    csvContent +=
      ",,,,,,,,,,Total:,," + formatAmount(totalNetAmount - totalAdvance) + "\n";
    csvContent += ",,,,,,,,,,Adv:,," + formatAmount(totalAdvance) + "\n";
    csvContent += ",,,,,,,,,,Phonepe:,," + formatAmount(totalPhonepe) + "\n";
    csvContent += ",,,,,,,,,,Card:,," + formatAmount(totalCard) + "\n";
    csvContent +=
      ",,,,,,,,,,Bank TF:,," + formatAmount(totalBankTransfer) + "\n";
    csvContent +=
      ",,,,,,,,,,Cash Bal:,," + formatAmount(totalCash + totalPayCash) + "\n";

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "general_bill_report.csv";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Handle Excel
  const downloadExcel = () => {
    const filteredData = getFilteredData();

    const headers = [
      "S.No",
      "Bill Date",
      "Bill No",
      "Customer",
      "PayType",
      "Brand",
      "Model",
      "HSN Code",
      "Charge Type",
      "Total",
      "PhonePe",
      "Cash",
      "Advance",
      "Cash Bal",
      "Technician",
      "Bill Staff",
    ];

    let excelContent = '<table border="1">';
    excelContent +=
      "<tr>" + headers.map((h) => `<th>${h}</th>`).join("") + "</tr>";

    const {
      totalNetAmount,
      totalPhonepe,
      totalCash,
      totalCard,
      balance,
      totalBankTransfer,
      totalAdvance,
      totalPayCash,
    } = calculateMetrics(filteredData);

    filteredData.forEach((item, index) => {
      const sNo = index + 1;

      const payment = item.payment?.[0] || {};

      /* ---------------- PHONEPE ---------------- */
      const phonePeAmount =
        item.Paytype?.toLowerCase() === "phonepe"
          ? formatAmount(payment.amount || 0)
          : "0.00";

      /* ---------------- CASH LOGIC (FIXED) ---------------- */
      const isCashPayment =
        item.Paytype?.toLowerCase() === "cash" ||
        payment.payment_type?.toLowerCase() === "cash";

      const cashAmount =
        parseFloat(item.cash || 0) +
        (isCashPayment ? parseFloat(payment.amount || 0) : 0);

      const cashDisplay = formatAmount(cashAmount);

      const balanceAmount = parseFloat(payment.balance || 0);
      const balanceDisplay = formatAmount(balanceAmount);

      if (item.service_list?.length > 0) {
        item.service_list.forEach((service, serviceIndex) => {
          excelContent += `<tr>
          <td>${sNo}</td>
          <td>${formatDate(item.date)}</td>
          <td>${item.bill_no || "N/A"}</td>
          <td>${item.name || "N/A"}</td>
          <td>${item.Paytype || "N/A"}</td>
          <td>${item.brand || "N/A"}</td>
          <td>${item.model || "N/A"}</td>
          <td>${service.hsnCode || "N/A"}</td>
          <td>${service.serviceName || "N/A"}</td>

          <td>${serviceIndex === 0 ? formatAmount(item.net_total) : 0}</td>

          <td>${phonePeAmount}</td>

          <td>${serviceIndex === 0 ? cashDisplay : 0}</td>

          <td>${
            serviceIndex === 0 ? formatAmount(item.advance_amount || 0) : 0
          }</td>

          <td>${serviceIndex === 0 ? cashDisplay : 0}</td>

          <td>${item.technician || "N/A"}</td>
          <td>${item.bill_staff || "N/A"}</td>
        </tr>`;
        });
      } else {
        excelContent += `<tr>
        <td>${sNo}</td>
        <td>${formatDate(item.date)}</td>
        <td>${item.bill_no || "N/A"}</td>
        <td>${item.name || "N/A"}</td>
        <td>${item.Paytype || "N/A"}</td>
        <td>${item.brand || "N/A"}</td>
        <td>${item.model || "N/A"}</td>
        <td></td>
        <td></td>

        <td>${formatAmount(item.net_total)}</td>

        <td>${phonePeAmount}</td>
        <td>${cashDisplay}</td>
        <td>${formatAmount(item.advance_amount || 0)}</td>
        <td>${cashDisplay}</td>

        <td>${item.technician || "N/A"}</td>
        <td>${item.bill_staff || "N/A"}</td>
      </tr>`;
      }
    });

    /* ---------------- FOOTER TOTAL ---------------- */
    excelContent += `<tr style="font-weight:bold; background-color:#f0f0f0;">
    <td colspan="9" style="text-align:right;">Total:</td>
    <td>${formatAmount(totalNetAmount - totalAdvance)}</td>
    <td>${formatAmount(totalPhonepe)}</td>
    <td>${formatAmount(totalCash + totalPayCash)}</td>
    <td>${formatAmount(totalAdvance)}</td>
    <td>${formatAmount(totalCash + totalPayCash)}</td>
    <td colspan="2"></td>
  </tr>`;

    /* ================= SUMMARY (CSV LIKE / PDF STYLE) ================= */
    excelContent += `
  <tr><td colspan="16">&nbsp;</td></tr>

  <tr style="font-weight:bold;">
    <td colspan="10" style="text-align:right;">Total :</td>
    <td colspan="2">${formatAmount(totalNetAmount - totalAdvance)}</td>
    <td colspan="4"></td>
  </tr>

  <tr style="font-weight:bold;">
    <td colspan="10" style="text-align:right;">Adv :</td>
    <td colspan="2">${formatAmount(totalAdvance)}</td>
    <td colspan="4"></td>
  </tr>

  <tr style="font-weight:bold;">
    <td colspan="10" style="text-align:right;">PhonePe :</td>
    <td colspan="2">${formatAmount(totalPhonepe)}</td>
    <td colspan="4"></td>
  </tr>

  <tr style="font-weight:bold;">
    <td colspan="10" style="text-align:right;">Card :</td>
    <td colspan="2">${formatAmount(totalCard)}</td>
    <td colspan="4"></td>
  </tr>

  <tr style="font-weight:bold;">
    <td colspan="10" style="text-align:right;">Bank TF :</td>
    <td colspan="2">${formatAmount(totalBankTransfer)}</td>
    <td colspan="4"></td>
  </tr>

  <tr style="font-weight:bold;">
    <td colspan="10" style="text-align:right;">Cash Bal :</td>
    <td colspan="2">${formatAmount(totalCash + totalPayCash)}</td>
    <td colspan="4"></td>
  </tr>
  `;

    excelContent += "</table>";

    const blob = new Blob([excelContent], {
      type: "application/vnd.ms-excel",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "general_bill_report.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  // Handle PDF
  const downloadPDF = () => {
    const filteredData = getFilteredData();
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 10;
    const usablePageWidth = pageWidth - margin * 2;

    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("WE CARE", pageWidth / 2, 15, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(
      "NO-113 & 114, Lighthouse Complex, Omalur Main Road, 4 Roads, Salem - 636009",
      pageWidth / 2,
      22,
      { align: "center", maxWidth: usablePageWidth },
    );

    doc.setFontSize(12);
    doc.text(
      `BillWise Summary From ${
        fromDate ? formatDate(fromDate) : formatCurrentDate()
      } to ${toDate ? formatDate(toDate) : formatCurrentDate()}`,
      pageWidth / 2,
      30,
      { align: "center" },
    );

    const headers = [
      "S.No",
      "Bill Date",
      "Bill No",
      "Customer",
      "PayT",
      "Brand",
      "Model",
      "HSN",
      "Charge",
      "Total",
      "PhonePe",
      "Cash",
      "Advance",
      "Cash Bal",
      "Tech",
      "Bill St",
    ];

    const tableData = filteredData.flatMap((item, index) => {
      // Calculate balance correctly from payment array
      const balanceAmount = parseFloat(item.payment?.[0]?.balance || 0);

      if (item.service_list.length > 0) {
        return item.service_list.map((service, serviceIndex) => [
          index + 1,
          formatDate(item.date),
          item.bill_no || "N/A",
          item.name || "N/A",
          item.Paytype || "N/A",
          item.brand || "N/A",
          item.model || "N/A",
          service.hsnCode || "N/A",
          service.serviceName || "N/A",
          serviceIndex === 0 ? formatAmount(item.net_total) : "0.00",
          // PhonePe
          item.Paytype?.toLowerCase() === "phonepe" ||
          item.payment?.[0]?.payment_type?.toLowerCase() === "phonepe"
            ? formatAmount(item.payment?.[0]?.amount || 0)
            : "0.00",
          // Cash (item.cash + paid cash if payment type is Cash)
          serviceIndex === 0
            ? formatAmount(
                item.payment?.[0]?.payment_type?.toLowerCase() === "cash" ||
                  item.Paytype?.toLowerCase() === "cash"
                  ? parseFloat(item.cash || 0) +
                      parseFloat(item.payment?.[0]?.amount || 0)
                  : parseFloat(item.cash || 0),
              )
            : "0.00",
          // Advance
          serviceIndex === 0 ? formatAmount(item.advance_amount || 0) : "0.00",
          // Cash Balance - Now correctly shows balance from payment
          serviceIndex === 0
            ? formatAmount(
                item.payment?.[0]?.payment_type?.toLowerCase() === "cash" ||
                  item.Paytype?.toLowerCase() === "cash"
                  ? parseFloat(item.cash || 0) +
                      parseFloat(item.payment?.[0]?.amount || 0)
                  : parseFloat(item.cash || 0),
              )
            : "0.00",
          item.technician || "N/A",
          item.bill_staff || "N/A",
        ]);
      } else {
        // No service_list case
        return [
          [
            index + 1,
            formatDate(item.date),
            item.bill_no || "N/A",
            item.name || "N/A",
            item.Paytype || "N/A",
            item.brand || "N/A",
            item.model || "N/A",
            "N/A",
            "N/A",
            formatAmount(item.net_total),
            item.Paytype?.toLowerCase() === "phonepe" ||
            item.payment?.[0]?.payment_type?.toLowerCase() === "phonepe"
              ? formatAmount(item.payment?.[0]?.amount || 0)
              : "0.00",
            item.payment?.[0]?.payment_type?.toLowerCase() === "cash" ||
            item.Paytype?.toLowerCase() === "cash"
              ? formatAmount(
                  parseFloat(item.cash || 0) +
                    parseFloat(item.payment?.[0]?.amount || 0),
                )
              : formatAmount(item.cash || 0),
            formatAmount(item.advance_amount || 0),
            item.Paytype?.toLowerCase() === "cash"
              ? formatAmount(
                  parseFloat(item.cash || 0) +
                    parseFloat(item.payment?.[0]?.amount || 0),
                )
              : formatAmount(item.cash || 0),
            item.technician || "N/A",
            item.bill_staff || "N/A",
          ],
        ];
      }
    });

    const {
      totalNetAmount,
      totalAdvance,
      totalPhonepe,
      totalPayCash,
      totalBankTransfer,
      totalCard,
      balance,
      totalCash,
    } = calculateMetrics(filteredData);

    const columnWidths = {
      0: 8,
      1: 15,
      2: 15,
      3: 25,
      4: 20,
      5: 15,
      6: 15,
      7: 15,
      8: 15,
      9: 18,
      10: 18,
      11: 15,
      12: 15,
      13: 15,
      14: 15,
      15: 15,
    };

    autoTable(doc, {
      startY: 35,
      head: [headers],
      body: tableData,
      theme: "striped",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [46, 146, 144],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      columnStyles: {
        0: { cellWidth: columnWidths[0], halign: "center" },
        1: { cellWidth: columnWidths[1], halign: "center" },
        2: { cellWidth: columnWidths[2], halign: "left" },
        3: { cellWidth: columnWidths[3], halign: "left" },
        4: { cellWidth: columnWidths[4], halign: "left" },
        5: { cellWidth: columnWidths[5], halign: "left" },
        6: { cellWidth: columnWidths[6], halign: "left" },
        7: { cellWidth: columnWidths[7], halign: "center" },
        8: { cellWidth: columnWidths[8], halign: "left" },
        9: { cellWidth: columnWidths[9], halign: "right" },
        10: { cellWidth: columnWidths[10], halign: "right" },
        11: { cellWidth: columnWidths[11], halign: "right" },
        12: { cellWidth: columnWidths[12], halign: "right" },
        13: { cellWidth: columnWidths[13], halign: "right" },
        14: { cellWidth: columnWidths[14], halign: "left" },
        15: { cellWidth: columnWidths[15], halign: "left" },
      },
      margin: { left: margin, right: margin },
      foot: [
        [
          ...Array(8).fill(""),
          "Total:",
          formatAmount(totalNetAmount - totalAdvance),
          formatAmount(totalPhonepe),
          // formatAmount(totalCash), // Cash (item.cash total)
          formatAmount(totalCash + totalPayCash),
          formatAmount(totalAdvance),
          formatAmount(totalCash + totalPayCash),
          "",
          "",
        ],
      ],
      footStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "right",
      },
    });

    const finalY = doc.lastAutoTable.finalY || 35;
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");

    const summaryLines = [
      `Total: ${formatAmount(totalNetAmount - totalAdvance)}`,
      `Adv: ${formatAmount(totalAdvance)}`,
      `Phonepe: ${formatAmount(totalPhonepe)}`,
      `Card: ${formatAmount(totalCard)}`,
      `Bank TF: ${formatAmount(totalBankTransfer)}`,
      `Cash Bal: ${formatAmount(totalCash + totalPayCash)}`,
    ];

    doc.text(summaryLines, pageWidth - margin, finalY + 8, { align: "right" });

    doc.save("general_bill_report.pdf");
  };

  // Handle Print
  const handlePrint = () => {
    const filteredData = getFilteredData();
    const startDate = fromDate ? formatDate(fromDate) : formatCurrentDate();
    const endDate = toDate ? formatDate(toDate) : formatCurrentDate();
    const {
      totalAmount,
      totalAdvance,
      totalPhonepe,
      totalPayCash,
      totalBankTransfer,
      totalCard,
      totalNetAmount,
      totalPaid,
      balance,
      totalCash,
    } = calculateMetrics(filteredData);

    const headers = [
      { name: "S.No", width: "3%" },
      { name: "Bill Date", width: "5%" },
      { name: "Bill No", width: "7%" },
      { name: "Customer", width: "8%" },
      { name: "PayType", width: "6%" },
      { name: "Brand", width: "6%" },
      { name: "Model", width: "7%" },
      { name: "HSN", width: "5%" },
      { name: "Charge Type", width: "7%" },
      { name: "Total", width: "5%" },
      { name: "PhonePe", width: "5%" },
      { name: "Cash", width: "5%" },
      { name: "Advance", width: "5%" },
      { name: "Cash Bal", width: "5%" },
      { name: "Tech", width: "7%" },
      { name: "Bill St", width: "7%" },
    ];

    const printWindow = window.open("", "_self");

    let printContent = `
      <html>
        <head>
          <title>Printable Report</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
              line-height: 1;
              background-color: #f8f9fa;
            }
            .container {
              max-width: 100%;
              margin: 0 auto;
            }
            button {
              padding: 10px 20px;
              font-size: 16px;
              background-color: #2e9290;
              color: white;
              border: none;
              border-radius: 5px;
              cursor: pointer;
              margin-bottom: 20px;
            }
            button:hover {
              background-color: #267876;
            }
            h2, h4 {
              text-align: center;
            }
            .address {
              text-align: center;
              font-size: 14px;
              margin-top: 7px;
            }
            .table-container {
              width: 100%;
              margin-top: 20px;
              overflow-x: auto;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
              table-layout: fixed;
            }
            th {
              border-top: 1px solid #000000;
              border-bottom: 1px solid #000000;
              border-left: none;
              border-right: none;
              padding: 5px 4px;
              text-align: left;
              background-color: #2e9290;
              color: #ffffff;
              font-weight: 600;
            }
            td {
              border: none;
              padding: 4px;
              text-align: left;
              vertical-align: middle;
              word-wrap: break-word;
            }
            td.align-right {
              text-align: right;
            }
            tfoot td,
            tr.total-row td {
              border-top: 1px solid #000;
              border-bottom: 1px solid #000;
              font-weight: bold;
            }
            .total {
              margin: 10px 10px 0 0;
              line-height: 1.8em;
              font-size: 10px;
              text-align: right;
            }
            @media print {
              body {
                margin: 0;
              }
              button {
                display: none;
              }
              .row {
                page-break-inside: avoid;
              }
              table {
                width: 100%;
              }
              th {
                background-color: transparent !important;
                color: black !important;
                font-weight: 600 !important;
              }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <button onclick="triggerPrint()">Print Report</button>
            <button onclick="Handleback()">Back</button>
            <h2 style="margin-top: 20px;">WE CARE</h2>
            <p class="address">NO-113 & 114, Lighthouse Complex, Omalur Main Road, 4 Roads, Salem - 636009</p>
            <h4>BillWise Summary From ${startDate} to ${endDate}</h4>
            <div class="table-container">
              <table>
                <thead>
                  <tr>
                    ${headers
                      .map((h) => {
                        const rightAlign = [
                          "Total",
                          "PhonePe",
                          "Cash",
                          "Advance",
                          "Cash Bal",
                        ].includes(h.name)
                          ? "text-align: right;"
                          : "text-align: left;";
                        return `<th style="width:${h.width}; ${rightAlign}">${h.name}</th>`;
                      })
                      .join("")}
                  </tr>
                </thead>
                <tbody>
    `;

    filteredData.forEach((item, index) => {
      // HandlePrint Balance amount
      const balanceAmount = parseFloat(item.payment?.[0]?.balance || 0);
      if (item.service_list.length > 0) {
        item.service_list.forEach((service, serviceIndex) => {
          printContent += `
            <tr>
              <td>${index + 1}</td>
              <td>${formatDate(item.date)}</td>
              <td>${item.bill_no || "N/A"}</td>
              <td>${item.name || "N/A"}</td>
              <td>${item.Paytype || "N/A"}</td>
              <td>${item.brand || "N/A"}</td>
              <td>${item.model || "N/A"}</td>
              <td>${service.hsnCode || "N/A"}</td>
              <td>${service.serviceName || "N/A"}</td>
              <td class="align-right">${
                serviceIndex === 0
                  ? "₹" + formatAmount(item.net_total)
                  : "₹0.00"
              }</td>
              <td class="align-right">
      ${
        item.Paytype && item.Paytype.toLowerCase() === "phonepe"
          ? "₹" + formatAmount(item.payment?.[0]?.amount || 0)
          : "₹0.00"
      }
    </td>
              <td class="align-right">
                ₹${
                  (serviceIndex === 0 &&
                    formatAmount(
                      item.Paytype?.toLowerCase() === "cash"
                        ? parseFloat(item.cash || 0) +
                            parseFloat(item.payment?.[0]?.amount || 0)
                        : parseFloat(item.cash || 0),
                    )) ||
                  "0.00"
                }
              </td>
              <td class="align-right">${
                serviceIndex === 0
                  ? "₹" + formatAmount(item.advance_amount)
                  : "₹" + "0.00"
              }</td>
              <td class="align-right">
              ₹${
                (serviceIndex === 0 &&
                  formatAmount(
                    item.Paytype?.toLowerCase() === "cash"
                      ? parseFloat(item.cash || 0) +
                          parseFloat(item.payment?.[0]?.amount || 0)
                      : parseFloat(item.cash || 0),
                  )) ||
                "0.00"
              }
              </td>
              <td>${item.technician || "N/A"}</td>
              <td>${item.bill_staff || "N/A"}</td>
            </tr>
          `;
        });
      } else {
        printContent += `
          <tr>
            <td>${index + 1}</td>
            <td>${formatDate(item.date)}</td>
            <td>${item.bill_no || "N/A"}</td>
            <td>${item.name || "N/A"}</td>
            <td>${item.Paytype || "N/A"}</td>
            <td>${item.brand || "N/A"}</td>
            <td>${item.model || "N/A"}</td>
            <td>N/A</td>
            <td>N/A</td>
            <td class="align-right">${"₹" + formatAmount(item.net_total)}</td>
            <td class="align-right">
      ${
        item.Paytype && item.Paytype.toLowerCase() === "phonepe"
          ? "₹" + formatAmount(item.payment?.[0]?.amount || 0)
          : "₹0.00"
      }
    </td>
            <td class="align-right">
              ₹${formatAmount(
                item.Paytype?.toLowerCase() === "cash"
                  ? parseFloat(item.cash || 0) +
                      parseFloat(item.payment?.[0]?.balance || 0)
                  : parseFloat(item.cash || 0),
              )}
            </td>
            <td class="align-right">₹${formatAmount(item.advance_amount)}</td>
            <td class="align-right">
              ₹${formatAmount(
                item.Paytype?.toLowerCase() === "cash"
                  ? parseFloat(item.cash || 0) +
                      parseFloat(item.payment?.[0]?.balance || 0)
                  : parseFloat(item.cash || 0),
              )}
            </td>
            <td>${item.technician || "N/A"}</td>
            <td>${item.bill_staff || "N/A"}</td>
          </tr>
        `;
      }
    });

    printContent += `
                </tbody>
                <tfoot>
                  <tr class="total-row">
                    <td colspan="9" style="text-align: right;">Total:</td>
                    <td class="align-right">₹${formatAmount(
                      totalNetAmount - totalAdvance,
                    )}</td>
                    <td class="align-right">₹${formatAmount(totalPhonepe)}</td>
                    <td class="align-right">₹${formatAmount(
                      totalCash + totalPayCash,
                    )}</td>
                    <td class="align-right">₹${formatAmount(totalAdvance)}</td>
                    <td class="align-right">₹${formatAmount(
                      totalCash + totalPayCash,
                    )}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
              <div class="total">
                <strong>
                  Total: ₹${formatAmount(totalNetAmount - totalAdvance)}<br>
                  Adv: ₹${formatAmount(totalAdvance)}<br>
                  Phonepe: ₹${formatAmount(totalPhonepe)}<br>
                  Card: ₹${formatAmount(totalCard)}<br>
                  Bank TF: ₹${formatAmount(totalBankTransfer)}<br>
                  Cash Bal: ₹${formatAmount(totalCash + totalPayCash)}<br><br>
                </strong>
              </div>
            </div>
            <script>
              function triggerPrint() {
                window.print();
              }
              function Handleback() {
                window.location.href = "/reports";
              }
              window.matchMedia('print').addListener((media) => {
                if (!media.matches) {
                  window.location.href = "/reports";
                }
              });
            </script>
          </body>
        </html>
    `;

    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
  };

  const renderPagination = () => {
    const totalPages = getTotalPages();
    if (totalPages <= 1 && itemsPerPage !== Number.MAX_SAFE_INTEGER)
      return null;

    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="text-muted">
          Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
          {Math.min(currentPage * itemsPerPage, getFilteredData().length)} of{" "}
          {getFilteredData().length} entries
        </div>
        {itemsPerPage !== Number.MAX_SAFE_INTEGER && (
          <div className="d-flex gap-2">
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            {pages.map((page) => (
              <button
                key={page}
                className={`btn btn-sm ${
                  currentPage === page ? "btn-success" : "btn-outline-secondary"
                }`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() =>
                setCurrentPage(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </div>
    );
  };

  const renderTable = () => {
    const filteredData = getFilteredData();
    const paginatedData = getPaginatedData();
    const headers = [
      "S.No",
      "Bill Date",
      "Bill No",
      "Customer",
      "PayType",
      "Brand",
      "Model",
      "HSN",
      "Charge Type",
      "Total",
      "PhonePe",
      "Cash",
      "Advance",
      "Cash Bal",
      "Technician",
      "Bill Staff",
    ];

    const {
      totalAdvance,
      totalPhonepe,
      totalPayCash,
      totalBankTransfer,
      totalCard,
      totalNetAmount,
      totalPaid,
      balance,
      totalCash,
    } = calculateMetrics(filteredData);

    const cashBalance = totalNetAmount - (totalAdvance - totalPhonepe);

    return (
      <div className="table-responsive">
        <table className="table table-hover">
          <thead>
            <tr style={{ backgroundColor: "#2e9290", color: "white" }}>
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="text-left"
                  style={{ backgroundColor: "#2e9290", color: "white" }}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.length === 0 ? (
              <tr>
                <td colSpan={headers.length} className="text-center">
                  No data available
                </td>
              </tr>
            ) : (
              paginatedData.flatMap((item) =>
                item.service_list.length > 0
                  ? item.service_list.map((service, serviceIndex) => (
                      <tr
                        key={`${item.bill_no}-${serviceIndex}`}
                        className="align-middle"
                      >
                        <td className="text-left">{item.sNo}</td>
                        <td className="text-left">{formatDate(item.date)}</td>
                        <td className="text-left">{item.bill_no}</td>
                        <td className="text-left">{item.name}</td>
                        <td className="text-left">{item.Paytype}</td>
                        <td className="text-left">{item.brand}</td>
                        <td className="text-left">{item.model}</td>
                        <td className="text-left">
                          {service.hsnCode || "N/A"}
                        </td>
                        <td className="text-left" style={{ width: "15%" }}>
                          {service.serviceName || "N/A"}
                        </td>
                        <td className="text-right">
                          {serviceIndex === 0
                            ? "₹" + formatAmount(item.net_total)
                            : "₹" + "0.00"}
                        </td>
                        {/* <td className="text-right">
                          ₹{formatAmount(item.payment_amount)}
                        </td> */}

                        <td className="text-right">
                          {item.Paytype &&
                          item.Paytype.toLowerCase() === "phonepe"
                            ? "₹" + formatAmount(item.payment_amount)
                            : "₹" + "0.00"}
                        </td>
                        {/*<td className="text-right">
                          {serviceIndex === 0
                            ? "₹" + formatAmount(item.cash)
                            : ""}
                        </td>*/}
                        <td className="text-right">
                          ₹
                          {(serviceIndex === 0 &&
                            formatAmount(
                              item.Paytype?.toLowerCase() === "cash"
                                ? parseFloat(item.cash || 0) +
                                    parseFloat(item.payment_amount || 0)
                                : parseFloat(item.cash || 0),
                            )) ||
                            "0.00"}
                        </td>
                        <td className="text-right">
                          {serviceIndex === 0
                            ? "₹" + formatAmount(item.advance_amount)
                            : "₹" + "0.00"}
                        </td>
                        {/* <td className="text-right">
                          {serviceIndex === 0
                            ? "₹" + formatAmount(item.balance)
                            : ""}
                        </td> */}
                        {/* <td className="text-right">
                          ₹

                          {item.payment?.[0]?.balance === 0
                            ? "0.00"
                            : formatAmount(item.payment?.[0]?.balance)}
                        </td> */}

                        <td className="text-right">
                          ₹
                          {(serviceIndex === 0 &&
                            formatAmount(
                              item.Paytype?.toLowerCase() === "cash"
                                ? parseFloat(item.cash || 0) +
                                    parseFloat(item.payment_amount || 0)
                                : parseFloat(item.cash || 0),
                            )) ||
                            "0.00"}
                        </td>
                        <td className="text-left">{item.technician}</td>
                        <td className="text-left">{item.bill_staff}</td>
                      </tr>
                    ))
                  : [
                      <tr key={item.bill_no} className="align-middle">
                        <td className="text-left">{item.sNo}</td>
                        <td className="text-left">{formatDate(item.date)}</td>
                        <td className="text-left">{item.bill_no}</td>
                        <td className="text-left">{item.name}</td>
                        <td className="text-left">{item.Paytype}</td>
                        <td className="text-left">{item.brand}</td>
                        <td className="text-left">{item.model}</td>
                        <td className="text-left">N/A</td>
                        <td className="text-left">N/A</td>
                        <td className="text-right">
                          {"₹" + formatAmount(item.net_total)}
                        </td>
                        <td className="text-right">
                          {item.Paytype &&
                          item.Paytype.toLowerCase() === "phonepe"
                            ? "₹" + formatAmount(item.payment_amount)
                            : "₹" + "0.00"}
                        </td>
                        <td className="text-right">
                          ₹{formatAmount(item.cash)}
                        </td>
                        <td className="text-right">
                          ₹{formatAmount(item.advance_amount)}
                        </td>
                        <td className="text-right">
                          "₹" + formatAmount(item.balance)
                        </td>
                        <td className="text-left">{item.technician}</td>
                        <td className="text-left">{item.bill_staff}</td>
                      </tr>,
                    ],
              )
            )}
          </tbody>
          <tfoot>
            <tr
              className="total-row"
              style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}
            >
              <td colSpan={9} className="text-right">
                Total:
              </td>
              <td className="text-right">
                ₹{formatAmount(totalNetAmount - totalAdvance)}
              </td>
              <td className="text-right">₹{formatAmount(totalPhonepe)}</td>
              {/* <td className="text-right">₹{formatAmount(totalCash)}</td> */}
              <td className="text-right">
                ₹{formatAmount(totalCash + totalPayCash)}
              </td>
              <td className="text-right">₹{formatAmount(totalAdvance)}</td>
              <td className="text-right">
                ₹{formatAmount(totalCash + totalPayCash)}
              </td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
        <div className="mt-2 text-end fw-bold">
          {/* Total */}
          <div className="d-flex justify-content-end">
            <div
              style={{ width: "180px" }}
              className="d-flex justify-content-between"
            >
              <span>Total</span>
              <span>₹{formatAmount(totalNetAmount - totalAdvance)}</span>
            </div>
          </div>

          {/* Advance */}
          <div className="d-flex justify-content-end">
            <div
              style={{ width: "180px" }}
              className="d-flex justify-content-between"
            >
              <span>Advance</span>
              <span>₹{formatAmount(totalAdvance)}</span>
            </div>
          </div>

          {/* PhonePe */}
          <div className="d-flex justify-content-end">
            <div
              style={{ width: "180px" }}
              className="d-flex justify-content-between"
            >
              <span>PhonePe</span>
              <span>₹{formatAmount(totalPhonepe)}</span>
            </div>
          </div>

          {/* Card */}
          <div className="d-flex justify-content-end">
            <div
              style={{ width: "180px" }}
              className="d-flex justify-content-between"
            >
              <span>Card</span>
              <span>₹{formatAmount(totalCard)}</span>
            </div>
          </div>

          {/* Bank Transfer */}
          <div className="d-flex justify-content-end">
            <div
              style={{ width: "180px" }}
              className="d-flex justify-content-between"
            >
              <span>Bank TF</span>
              <span>₹{formatAmount(totalBankTransfer)}</span>
            </div>
          </div>

          {/* Cash Balance */}
          <div className="d-flex justify-content-end">
            <div
              style={{ width: "180px" }}
              className="d-flex justify-content-between"
            >
              <span>Cash Bal</span>
              <span>₹{formatAmount(totalCash + totalPayCash)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div
      className="container-fluid p-3"
      style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}
    >
      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}
      <div className="card card-body mt-2">
        <div
          className="card-header d-flex justify-content-between align-items-center p-3"
          style={{ backgroundColor: "#2e9290", color: "white" }}
        >
          <h5 className="mb-0">Report</h5>
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <span className="d-flex flex-column">
              <label className="text-white">Brand</label>
              <select
                className="form-select form-select-sm"
                value={selectedBrand}
                onChange={(e) => {
                  setSelectedBrand(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All</option>
                {brands.map((brand, index) => (
                  <option key={index} value={brand.brand_name}>
                    {brand.brand_name}
                  </option>
                ))}
              </select>
            </span>
            <span className="d-flex flex-column">
              <label className="text-white">Model</label>
              <select
                className="form-select form-select-sm"
                value={selectedModel}
                onChange={(e) => {
                  setSelectedModel(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All</option>
                {models.map((model, index) => (
                  <option key={index} value={model.model_name}>
                    {model.model_name}
                  </option>
                ))}
              </select>
            </span>
            <span className="d-flex flex-column">
              <label className="text-white">Charge Type</label>
              <select
                className="form-select form-select-sm"
                value={selectedServiceHome}
                onChange={(e) => {
                  setSelectedServiceHome(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All</option>
                {serviceTypes.map((service, index) => (
                  <option key={index} value={service.serviceName}>
                    {service.serviceName}
                  </option>
                ))}
              </select>
            </span>
            <span className="d-flex flex-column">
              <label className="text-white">Pay Type</label>
              <select
                className="form-select form-select-sm"
                value={paytype}
                onChange={(e) => {
                  setPaytype(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Payment Type</option>
                <option value="Phonepe">Phonepe</option>
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="Bank Transfer">Bank Transfer</option>
              </select>
            </span>
            <span className="d-flex flex-column">
              <label className="text-white">Bill Type</label>
              <select
                className="form-select form-select-sm"
                value={billType}
                onChange={(e) => {
                  setBillType(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All</option>
                <option value="general">General</option>
                <option value="motorola">Motorola</option>
                <option value="gst">GST</option>
              </select>
            </span>
            <span className="d-flex flex-column mt-4">
              <div className="d-flex gap-2">
                <div className="d-flex flex-column">
                  <label className="text-white small">From Date:</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={fromDate}
                    onChange={(e) => {
                      setFromDate(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
                <div className="d-flex flex-column">
                  <label className="text-white small">To Date:</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={toDate}
                    onChange={(e) => {
                      setToDate(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </span>
            <button
              className="btn btn-outline-light btn-sm mt-4"
              onClick={() => {
                setSelectedBrand("");
                setSelectedModel("");
                setSelectedServiceHome("");
                setBillType("");
                setPaytype("");
                setFromDate("");
                setToDate("");
                setCurrentPage(1);
              }}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="card-body">
          <div className="row mb-4 align-items-center">
            <div className="col-md-3">
              <div className="input-group">
                <span className="input-group-text">
                  <i className="fas fa-table"></i>
                </span>
                <select
                  className="form-select"
                  value={
                    itemsPerPage === Number.MAX_SAFE_INTEGER
                      ? "All"
                      : itemsPerPage
                  }
                  onChange={(e) => {
                    setItemsPerPage(
                      e.target.value === "All"
                        ? Number.MAX_SAFE_INTEGER
                        : Number(e.target.value),
                    );
                    setCurrentPage(1);
                  }}
                >
                  <option value="All">Show All</option>
                  {[5, 10, 20, 50, 100].map((n) => (
                    <option key={n} value={n}>
                      Show {n}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-1"></div>
            <div className="col-md-5 mb-2">
              <div className="d-flex flex-wrap gap-2">
                <button
                  className="btn btn-success btn-sm d-flex align-items-center gap-1"
                  onClick={downloadPDF}
                >
                  <FileText size={16} />
                  PDF
                </button>
                <button
                  className="btn btn-success btn-sm d-flex align-items-center gap-1"
                  onClick={downloadExcel}
                >
                  <FileSpreadsheet size={16} />
                  Excel
                </button>
                <button
                  className="btn btn-success btn-sm d-flex align-items-center gap-1"
                  onClick={downloadCSV}
                >
                  <Download size={16} />
                  CSV
                </button>
                <button
                  className="btn btn-success btn-sm d-flex align-items-center gap-1"
                  onClick={handlePrint}
                >
                  <Printer size={16} />
                  Print
                </button>
              </div>
            </div>
            <div className="col-md-3 mb-2">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control form-control-sm pe-5"
                  placeholder="Search..."
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Search
                  size={16}
                  className="position-absolute text-muted"
                  style={{
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
            </div>
          </div>
          {renderTable()}
          {renderPagination()}
        </div>
      </div>
    </div>
  );
};

export default Report;
